import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import {ResponseType} from "./ResponseType";
import {getMessage} from "../util";

const ErrorResponse = (props:ResponseType) => {
    return(
        <Row className={"justify-content-center"}>
            <Col xs={12} sm={11} md={9} lg={7} className={"text-center"}>
                <p className={"lead"}>{getMessage('error_response', props.messages)}</p>
                <Button className="EvColorGrisLight m-1" onClick={props.volver}
                        variant="light">{getMessage('ask_again', props.messages)}</Button>
            </Col>
        </Row>
    )
}

export default ErrorResponse;